import { Reducer } from 'redux';
import AlectsActionTypes from './types';
import { AlectsState } from './types';

export const initialState: AlectsState = {
  data: []
};

const reducer: Reducer<AlectsState> = (state = initialState, action: any) => {
  switch (action.type) {
    case AlectsActionTypes.ADD_ALERT:
      return {
        ...state,
        data: [...state.data, action.payload]
      };
    case AlectsActionTypes.REMOVE_ALERT:
      return {
        ...state,
        data: state.data.filter((alert) => alert.id !== action.payload)
      };
    case AlectsActionTypes.REMOVE_ALERT_BY_GROUP:
      return {
        ...state,
        data: state.data.filter((alert) => alert.group !== action.payload)
      };
    case AlectsActionTypes.REMOVE_ALL_ALERTS:
      return {
        ...state,
        data: []
      };
    default:
      return state;
  }
};

export { reducer as AlertsReducer };
